import { useState } from "react";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { LevageList } from "./LevageList";
import { Segmented } from "antd";
import { useSearchParams } from "react-router";
import { LevageHistoryList } from "./LevageHistoryList";
import { MdFormatListBulleted } from "react-icons/md";
import { MdHistory } from "react-icons/md";

enum Show_mode {
  list = "list",
  history = "history",
}

const SHOW_MODE_OPTIONS = [
  {
    icon: (
      <MdFormatListBulleted
        style={{
          fontSize: "20px",
        }}
      />
    ),
    value: Show_mode.list,
  },
  {
    icon: (
      <MdHistory
        style={{
          fontSize: "20px",
        }}
      />
    ),
    value: Show_mode.history,
  },
];

export const LevagePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialView = searchParams.get("mode") || Show_mode.list;

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [selectedMode, setSelectedMode] = useState<string>(initialView);

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const handleChangeViewMode = (value: any) => {
    // const mode = value;
    setSelectedMode(value);
    setSearchParams({ mode: value });
  };
  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-end ">
        <TitleHeader
          title={`${
            selectedMode === Show_mode.history ? "Historique contrôle" : ""
          } Accessoires de levage`}
          isSHowBack
          backUri="/app/material"
          isEnableAdd={selectedMode !== Show_mode.history}
          onClickOnAdd={onShowAddHandler}
        />
        <div className=" ">
          <div className="flex-full mt-4">
            <Segmented
              // size={size}
              shape="round"
              value={selectedMode}
              onChange={handleChangeViewMode}
              options={SHOW_MODE_OPTIONS}
            />
            {/* <Radio.Group
              block
              options={SHOW_MODE_OPTIONS}
              optionType="button"
              buttonStyle="solid"
              // defaultValue={}
              value={selectedMode}
              onChange={handleChangeViewMode}
            /> */}
          </div>
        </div>
      </div>
      <div className="mt-4">
        {selectedMode === Show_mode.list ? (
          <LevageList
            isShowForm={isShowForm}
            onShowAddHandler={onShowAddHandler}
          />
        ) : (
          <LevageHistoryList
            isShowDrawer={isShowForm}
            onShowDrawerHandler={onShowAddHandler}
          />
        )}
      </div>
    </div>
  );
};
